import axios from 'axios';
import errorHandlerFactory from './errorHandler';
import { filterSummaries } from './adapters/csaImpactAdapter';

const errorHandler = errorHandlerFactory('An error occured when sending compare csas.');

// eslint-disable-next-line import/prefer-default-export
export const csaRequest = params => axios.post('/CsaImpact/UpdatedCsaCompareComp', params)
    .then(r => filterSummaries(r.data)).catch(errorHandler);
